import { render } from "./CIS-Healthcare-Graphic-Card.vue?vue&type=template&id=0b4bb500&scoped=true"
import script from "./CIS-Healthcare-Graphic-Card.vue?vue&type=script&lang=js"
export * from "./CIS-Healthcare-Graphic-Card.vue?vue&type=script&lang=js"

import "./CIS-Healthcare-Graphic-Card.vue?vue&type=style&index=0&id=0b4bb500&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4bb500"]])

export default __exports__